import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { isBrowser } from 'ws-scripts/modules/environment';
import { usePrefs, useRequestData, useLabels } from 'wsm-common-data';

import { getTargetLocations } from '../utils/getTargetLocations';
import { getDOMContainer } from '../utils/getDOMContainer';
import { getVehicleToolbarCTAs } from '../utils/getVehicleToolbarCTAs';

import ErrorBoundaryWrapper from '../components/shared/ErrorBoundaryWrapper';
import CTAButtonList from '../components/widgets/CTAButtonList';
import ConditionalPortalWrapper from '../components/shared/ConditionalPortalWrapper';

const Widget = () => {
	const labels = useLabels();
	const {
		items,
		vehicle,
		widgetInfo: { isComposer, isDigitalRetailingEnabled }
	} = useSelector((state) => state);

	const { deviceType } = useRequestData();
	const isMobile = deviceType === 'MOBILE';

	const { restrictInsertLocationsForVehicles, mobileCtaLocation } =
		usePrefs();
	const targetLocations = getTargetLocations(
		vehicle,
		restrictInsertLocationsForVehicles
	);

	const ctaButtonsArr = targetLocations.has('vehicle-ctas') ? [] : items;
	const pubsub = isBrowser && window?.DDC?.pubsub;

	useEffect(() => {
		if (pubsub) {
			setTimeout(
				() => pubsub.publish('ws-vehicle-ctas/render-eprice-portal'),
				1000
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		// If isDigitalRetailingEnabled = true, ws-vehicle-toolbar will get its CTAs
		// from the ws-track-my-offer widget instead.
		if (items?.length > 0 && !isDigitalRetailingEnabled) {
			const vehicleToolbarCTAs = getVehicleToolbarCTAs(
				items,
				labels,
				isMobile
			);
			pubsub?.publishDelayed(
				'ws-vehicle-toolbar/show-vehicle-ctas',
				vehicleToolbarCTAs
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [items, labels, isMobile, isDigitalRetailingEnabled]);

	const showCTAsInPortal =
		mobileCtaLocation === 'portal' && isMobile && !isComposer && isBrowser;

	const mobilePortalContainer = showCTAsInPortal
		? getDOMContainer(document, '.ddc-vehicle-cta-summary')
		: null;

	return (
		<ErrorBoundaryWrapper>
			{/* conditionally return a react portal for CTAs */}
			<ConditionalPortalWrapper container={mobilePortalContainer}>
				<CTAButtonList
					targetLocations={targetLocations}
					buttons={ctaButtonsArr}
				/>
			</ConditionalPortalWrapper>
		</ErrorBoundaryWrapper>
	);
};

export default Widget;
